export default (state, action) => {
  switch (action.type) {
    case 'SWITCH':
      return {
        ...state,
        currentTheme: action.payload,
      };

    case 'SET_CUSTOM':
      return { ...state, themes: action.payload };

    case 'SET_REPORT_THEME':
      return { ...state, reportTheme: action.payload };
    default:
      return state;
  }
};
